import { PickingProofEventItemType } from './PickingProofEventItemType'
import { FulfillmentIssueResolvedEventItemType } from './FulfillmentIssueResolvedEventItemType'
import { useTranslation } from 'react-i18next'

const EventItemType = ({orderId, event}) => {
    const [t] = useTranslation()

    if (event.type === 'PICKING_PROOF_ADDED') {
        return <PickingProofEventItemType orderId={orderId} event={event}/>
    }

    if ([
        'FOUND_ITEM',
        'PARTIAL_AVAILABILITY',
        'SUBSTITUTION',
        'REPLACEMENT_ITEM',
        'OUT_OF_ITEM',
    ]
      .some(prefix => event.type.startsWith(`${prefix}:`))) {
        const [fulfillmentIssue, itemName] = event.type.split(':')
        return t(`order.history.status.${fulfillmentIssue}`, {itemName})
    }

    if (event.type === 'FULFILLMENT_ISSUES_RESOLVED') {
        return <FulfillmentIssueResolvedEventItemType event={event}/>
    }

    if ([
        'STATUS_RECEIVED',
        'STATUS_VIEWED',
        'STATUS_ACCEPTED',
        'STATUS_READY',
        'STATUS_PREPARING',
        'STATUS_DENIED',
        'STATUS_EXPIRED',
        'STATUS_ALREADY_EXPIRED',
        'STATUS_CANCELLED',
        'STATUS_COMPLETED',
        'SYNC',
    ].includes(event.type)) {
        return t(`order.history.status.${event.type}`)
    }

    if (event.type.includes('STATUS_UPDATE_COURIER_')) {
        const count = event.type.split('_')[3]
        return t('order.history.status.COURIER_ADDED', {count: +count})
    }

    return event.type
}

export { EventItemType }
